import { useState, useEffect } from 'react';
/**
 *
 * @param element ref of the element to be tracked
 * @param rootMargin offset when the element becomes visible
 * @returns boolean value if the element is in view or not
 */

// e.g.
// const inViewport = useIntersection(ref, '0px'); - Trigger as soon as the element becomes visible

export const useIntersection = (
  element: React.MutableRefObject<HTMLDivElement>,
  rootMargin: string
) => {
  const [isVisible, setVisibility] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisibility(entry.isIntersecting);
      },
      { rootMargin }
    );

    element.current && observer.observe(element.current);

    return () => element.current && observer.unobserve(element.current);
  }, []);

  return isVisible;
};
